import { action, computed, makeObservable } from 'mobx';

import { AUTH_MODES } from '@/configs/authMode';
import { ENDPOINTS } from '@/configs/endpoints';
import { sessionStore } from '@/stores/global/RootStore';
import { ILocalStore } from '@/stores/interfaces/ILocalStore';
import { MetaStore } from '@/stores/local/shared/MetaStore';
import call from '@/utils/api';

export class LoginMethodPageStore implements ILocalStore {
  readonly loadAlfaUrlMeta = new MetaStore();

  constructor() {
    makeObservable(this, {
      isAlfaAvailable: computed,
      isPhoneOnly: computed,
      redirectToAlfa: action.bound,
    });
  }

  /** Вход через Alfa-ID доступен только в режиме `alfa_id` */
  get isAlfaAvailable() {
    return sessionStore.authMode === AUTH_MODES.ALFA_ID;
  }

  /** Единственный доступный способ входа — телефон (режим `phone_totp_only`) */
  get isPhoneOnly() {
    return sessionStore.authMode === AUTH_MODES.PHONE_TOTP_ONLY;
  }

  async redirectToAlfa(): Promise<void> {
    this.loadAlfaUrlMeta.setLoadedStartMeta();

    const response = await call<{ url: string }>({
      endpoint: ENDPOINTS.auth.alfaUrl,
    });

    if (response.isError) {
      this.loadAlfaUrlMeta.setLoadedErrorMeta();

      return;
    }

    this.loadAlfaUrlMeta.setLoadedSuccessMeta();
    window.location.href = response.data.url;
  }

  destroy(): void {
    this.loadAlfaUrlMeta.destroy();
  }
}
